import Fuse from "fuse.js"

export const createSearchService = ( list, fields ) => {

	const minSearchLength = 2

	const fuse = new Fuse( list, {
		useExtendedSearch: true,
		minMatchCharLength: minSearchLength,
		threshold: 0.3,
		keys: [ ...fields ],
	} )

	const search = query => {
		query = query
			.trim()
			.replace( /\s+/g, '|' ) // force an "OR" search

		if ( query.length < minSearchLength ) {
			return []
		}

		const rs = fuse
			.search( query )
			.map( r => r.item )

		return rs
	}

	return {
		search,
	}
}
